import QRCode from 'qrcode';
import React from 'react';
import styled, { StyledComponent } from 'styled-components';
import * as styles from './styles';

interface SunbitQRCodeProps {
  link: string;
  className?: string;
  dimension?: number;
}

export const SunbitQRCode: StyledComponent<React.FC<SunbitQRCodeProps>, {}> = styled(({ link, className, dimension = 100 }: SunbitQRCodeProps) => {
  const canvasRef = React.useRef(null);
  React.useEffect(() => {
    if (canvasRef.current) QRCode.toCanvas(document.getElementById('sunbit-qr-container'), link, { width: dimension });
  }, [canvasRef.current]);

  return <canvas width={20} height={20} className={className} ref={canvasRef} id={'sunbit-qr-container'}></canvas>;
})`
  ${styles.SunbitQRCode}
`;
